/* eslint-disable no-unused-vars */
export const convertArrayToTree = (array: any[], treeName: string) => {
  const idToNodeMap: Map<string, any> = new Map();
  const tree: any[] = [];

  // Первичная инициализация карты
  array.forEach((item) => {
    const node = { ...item, name: item.text, tree: treeName, children: [] };
    delete node.text;
    node.id = node.id.toString();
    idToNodeMap.set(node.id, node);
  });

  // Связывание узлов
  idToNodeMap.forEach((node) => {
    if (node.parent === '#') {
      tree.push(node);
    } else {
      const parentId = node.parent.toString();
      const parent = idToNodeMap.get(parentId);
      if (parent) {
        parent.children.push(node);
      }
    }
  });

  return tree;
};
